import { render, staticRenderFns } from "./information-list-item.vue?vue&type=template&id=8306dc28&scoped=true&"
import script from "./information-list-item.vue?vue&type=script&lang=js&"
export * from "./information-list-item.vue?vue&type=script&lang=js&"
import style0 from "./information-list-item.vue?vue&type=style&index=0&id=8306dc28&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8306dc28",
  null
  
)

export default component.exports